import { useStore } from "../lib/store";
import { iconButtonClass } from "./ThemeToggle";

export function SoundToggle() {
  const soundOn = useStore((s) => s.soundOn);
  const setSound = useStore((s) => s.setSound);
  const label = soundOn ? "Ton ausschalten" : "Ton einschalten";
  return (
    <button type="button" className={iconButtonClass} aria-label={label} title={label} onClick={() => setSound(!soundOn)}>
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5H4Z" />
        {soundOn ? <path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" /> : <path d="m16 9.5 5 5m0-5-5 5" />}
      </svg>
    </button>
  );
}
